module.exports = __webpack_public_path__ + "static/media/005_api_universe_zoomed.33e6995b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/intel/005_api_universe_zoomed.png
// module id = 476
// module chunks = 0